export default __webpack_public_path__ + "static/media/RealtyWorld.27bd1232.jpg";